import * as React from "react";

interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

interface EmptyStateProps {
  message?: string;
  action?: EmptyStateAction;
}

export function EmptyState({
  message = "Нет данных",
  action,
}: EmptyStateProps): React.JSX.Element {
  return (
    <div
      className="flex flex-col items-center justify-center py-16 px-4 text-center"
      role="status"
      aria-label={message}
    >
      <svg
        className="w-12 h-12 text-[var(--muted)] mb-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
        />
      </svg>
      <p className="text-[var(--muted)] text-[15px] mb-4">{message}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="text-[var(--accent)] text-[14px] font-[500] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] rounded px-2 py-1 min-h-[44px] min-w-[44px]"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
